import {useState} from "react";
import {Modal, Upload, message, Button} from "antd";
import {UploadOutlined, PictureOutlined} from "@ant-design/icons";
import "./UploadAvatarModal.css"

const UploadAvatarModal = ({open, onClose, onUpload, imageId}) => {
    const [fileList, setFileList] = useState([]);

    const handleChange = ({fileList: newFileList}) => setFileList(newFileList);

    const handleUpload = async () => {
        if (fileList.length === 0) {
            message.warning("Please select an image to upload");
            return;
        }

        const uploadedFile = fileList[0];

        try {
            // 🔹 Simulate server upload
            await onUpload(uploadedFile, imageId);

            message.success(`Successfully uploaded: ${uploadedFile.name}`);

            // ✅ Clear file list and close modal
            setFileList([]);
            onClose();
        } catch (error) {
            message.error("Upload failed. Please try again.");
        }
    };

    return (
        <Modal
            title={null}
            open={open}
            onCancel={() => {
                setFileList([]);
                onClose();
            }}
            footer={null}
            centered
            className="upload-avatar-modal"
        >
            <div className="upload-avatar-content">
                <div className="upload-header">
                    <PictureOutlined style={{fontSize: 28, color: "#3f96ff"}}/>
                    <h2>Upload New Avatar</h2>
                    <p>Select and upload your profile or company image.</p>
                </div>

                <Upload
                    listType="picture-card"
                    fileList={fileList}
                    onChange={handleChange}
                    beforeUpload={() => false}
                    accept="image/png,image/jpeg,image/webp,image/svg+xml,.svg"
                    className="upload-box"
                >
                    {fileList.length < 1 && (
                        <div>
                            <UploadOutlined style={{fontSize: 26, color: "#3f96ff"}}/>
                            <div style={{marginTop: 8}}>Click or drag image</div>
                        </div>
                    )}
                </Upload>

                {fileList.length > 0 && (
                    <div className="preview-container">
                        <img
                            src={URL.createObjectURL(fileList[0].originFileObj)}
                            alt="Preview"
                            className="preview-image"
                        />
                    </div>
                )}

                <div className="upload-tip">
                    💡 Image should be under 5MB. Supported formats: JPG, PNG, WEBP, SVG.
                </div>

                <div className="upload-buttons">
                    <Button
                        onClick={() => {
                            setFileList([]);
                            onClose();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        onClick={handleUpload}
                        disabled={fileList.length === 0}
                    >
                        Upload
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default UploadAvatarModal;
